import { accessMemberQueryKey } from '@/fsd/entities/access/consts/accessMemberQueryKey';
import { fetchAccessMember } from '@/fsd/entities/access/helpers/fetchAccessMember';
import { getAllClosureMonths } from '@/fsd/entities/closure-months/api/getAllClosureMonths/getAllClosureMonths';
import { updateClosureMonth } from '@/fsd/entities/closure-months/api/updateClosureMonth/updateClosureMonth';
import { queryClient } from '@/fsd/shared/lib/react-query/queryClient';
import { makeAutoObservable, runInAction } from 'mobx';
import { MONTHS_STATUSES } from './consts';

class ClosureMonthsStore {
  closureMonths = [];
  allClosureMonths = [];
  selectedYear = new Date().getFullYear().toString();
  years = [];

  constructor() {
    makeAutoObservable(this);
    // void this.fetchAllClosureMonths();
  }

  async checkIfGetAllClosureMonthsAvailable() {
    const queryClientData = await queryClient.fetchQuery({
      queryKey: accessMemberQueryKey,
      queryFn: fetchAccessMember,
    });

    return queryClientData.accessMember
      .find((section) => section.section === 'period_closure')
      .permissions.find(
        (permission) => permission.code === 'get_all_months_for_open'
      );
  }

  async loadYears() {
    try {
      const isAvailable = await this.checkIfGetAllClosureMonthsAvailable();

      if (!isAvailable) return;
      const data = await getAllClosureMonths();
      const yearsSet = new Set();

      data.forEach((month) => {
        if (!yearsSet.has(month.year)) {
          yearsSet.add(String(month.year));
        }
      });

      runInAction(() => {
        this.years = new Array(...yearsSet);
      });
    } catch (e) {
      throw e;
    }
  }

  async fetchClosureMonths() {
    try {
      const isAvailable = await this.checkIfGetAllClosureMonthsAvailable();

      if (!isAvailable) return;

      const queryParams = new URLSearchParams();
      queryParams.set('year', this.selectedYear);

      const data = await getAllClosureMonths(queryParams);

      runInAction(() => {
        this.closureMonths = data || [];
      });
    } catch (e) {
      throw e;
    }
  }

  async fetchAllClosureMonths() {
    try {
      const isAvailable = await this.checkIfGetAllClosureMonthsAvailable();

      if (!isAvailable) return;

      const data = await getAllClosureMonths();

      runInAction(() => {
        this.allClosureMonths = data || [];
      });
    } catch (e) {
      throw e;
    }
  }

  async setYear(year) {
    this.selectedYear = year;
    await this.fetchClosureMonths();
  }

  async toggleMonthStatus(monthId) {
    const month = this.closureMonths.find((m) => m.id === monthId);
    if (!month) return;

    const newStatus =
      month.status === MONTHS_STATUSES.OPEN
        ? MONTHS_STATUSES.CLOSE
        : MONTHS_STATUSES.OPEN;

    try {
      await updateClosureMonth({ id: monthId, status: newStatus });

      const index = this.closureMonths.findIndex((m) => m.id === monthId);

      runInAction(() => {
        if (index !== -1) {
          this.closureMonths[index] = {
            ...this.closureMonths[index],
            status: newStatus,
          };
        }
      });
    } catch (e) {
      console.error('Failed to update month status:', e);
    }
  }
}

export const closureMonthsStore = new ClosureMonthsStore();
